import { Controller } from "@hotwired/stimulus";

// Opens the mobile calendar agenda at today rather than at the 1st of the
// month, so a reader lands on what's relevant and scrolls up for what already
// happened. The month's whole list stays in the DOM — this only moves the
// scroll position.
//
// Usage:
//   <div data-controller="calendar-agenda">
//     <a data-action="click->calendar-agenda#jumpToToday">Today</a>
//     <div data-calendar-agenda-target="scroller" class="overflow-y-auto relative">
//       <div data-calendar-agenda-target="anchor">…today's group…</div>
//     </div>
//   </div>
export default class extends Controller<HTMLElement> {
  static targets = ["scroller", "anchor"];

  declare readonly scrollerTarget: HTMLElement;
  declare readonly hasScrollerTarget: boolean;
  declare readonly anchorTargets: HTMLElement[];

  connect() {
    this.jumpToToday();
  }

  // Deliberately does not preventDefault: from another month the Today control
  // still has to navigate, and `connect` re-runs after that render and scrolls
  // again. On the current month the scroll is all that's needed.
  jumpToToday() {
    if (!this.hasScrollerTarget) return;

    const anchor = this.anchorTargets[0];
    if (!anchor) return;

    // scrollTop against the scroller, not `scrollIntoView`: that scrolls every
    // scrollable ancestor too, dragging the page header off screen.
    this.scrollerTarget.scrollTop = anchor.offsetTop;
  }
}
